// extracted by mini-css-extract-plugin
export default {"RMSVerticalSpacingBlock":"RMSVerticalSpacingBlock_RMSVerticalSpacingBlock__bG3zp"};